import { useEffect } from "react";
import Cookies from "js-cookie";
import { FaFacebook } from "react-icons/fa";
import Swal from "sweetalert2";

const FacebookLoginButton = ({
  mode = "login",
  onUserData,
}) => {

  useEffect(() => {
    if (typeof window !== "undefined") {

      const checkFB = setInterval(() => {

        if (window.FB) {

          window.FB.init({
            appId: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID,
            cookie: true,
            xfbml: true,
            version: "v19.0",
          });

          clearInterval(checkFB);
        }

      }, 100);
    }
  }, []);

  const handleFBLogin = () => {

    if (!window.FB) {

      Swal.fire({
        icon: "error",
        title: "Facebook SDK not loaded",
      });

      return;
    }

    window.FB.login(
      (response) => {

        if (response.authResponse) {

          const { accessToken, userID } =
            response.authResponse;

          // ✅ GET USER DATA
          window.FB.api(
            "/me",
            { fields: "name,email" },

            async function (userInfo) {

              // ✅ CONTACT PAGE MODE
              if (mode === "contact") {

                onUserData?.({
                  name: userInfo.name || "",
                  email: userInfo.email || "",
                  mobile: "",
                });

                return;
              }

              // ✅ NORMAL LOGIN FLOW
              const res = await fetch(
                "https://www.qritagya.com/app/api/auth/facebook-login/",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    accessToken,
                    userID,
                  }),
                }
              );

              const data = await res.json();

              if (res.ok && data.success) {
                // Explicitly set cookie in frontend JS
                Cookies.set("token", data.token, { expires: 7, secure: true });

                if (data.user) {
                  localStorage.setItem("user", JSON.stringify(data.user));
                }

                const qr = Cookies.get("current_qr");
                window.location.href = qr ? "/app/dashboard/add-item" : "/app/dashboard";
              } else {

                Swal.fire({
                  icon: "error",
                  title: "Login failed!",
                });

              }
            }
          );

        } else {

          Swal.fire({
            icon: "info",
            title: "Facebook login cancelled.",
          });

        }
      },

      {
        scope: "email,public_profile",
      }
    );
  };

  return (
    <button
      onClick={handleFBLogin}
      className="d-flex align-items-center justify-content-center border rounded bg-white"
      style={{
        height: "33px",
        fontSize: "14px",
        fontWeight: 400,
        borderColor: "#dadce0",
        width: "100%",
      }}
    >
      <FaFacebook
        size={18}
        color="#1877f2"
        style={{ marginRight: "8px" }}
      />

      <span style={{ color: "#3c4043" }}>
        Sign in with Facebook
      </span>
    </button>
  );
};

export default FacebookLoginButton;